// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { mintSepoliaTestnet as _mintSepoliaTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the mintSepoliaTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1686
 * Chain Name: Mint Sepolia Testnet
 * Default Block Explorer: https://testnet-explorer.mintchain.io
 * Default RPC URL: https://testnet-rpc.mintchain.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { mintSepoliaTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: mintSepoliaTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const mintSepoliaTestnet = createCommon({
	..._mintSepoliaTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
